// File: /js/shared/handlers/handleAjaxOnInput.js

import { buildContext } from '/js/shared/context/requestContext.js';
import { ajaxAction }   from '/js/shared/ajax/ajaxAction.js';

let debounceTimers = new WeakMap();

export function handleAjaxOnInput(event) {
  const el = event.target.closest('[data-ajax-oninput="true"]');
  if (!el || !el.dataset.name) return;

  // Opt-in min-length gate (e.g. the content search). A non-empty value
  // shorter than the threshold is ignored — it can only match the full
  // list server-side anyway. An EMPTY value still fires so clearing the
  // field resets to the full list. Inputs without the attribute are
  // unaffected.
  const minLen = parseInt(el.dataset.ajaxMinLength ?? '', 10);
  if (Number.isFinite(minLen) && minLen > 0 && typeof el.value === 'string') {
    const len = el.value.trim().length;
    if (len > 0 && len < minLen) {
      if (debounceTimers.has(el)) {
        clearTimeout(debounceTimers.get(el));
        debounceTimers.delete(el);
      }
      return;
    }
  }

  if (debounceTimers.has(el)) {
    clearTimeout(debounceTimers.get(el));
  }

  const timer = setTimeout(() => {
    // `buildContext(el)` applies the scope-hash override if `el` is
    // inside an `[data-scope-hash]` ancestor (e.g. richtext editor
    // embedded inside an associated social-card). Without this, AJAX
    // would dispatch against the URL's hash and the server resolver
    // wouldn't have a registered handler for the embedded content.
    const data = {
      ...buildContext(el),
      ...el.dataset
    };
    // Extract the parent .block block-id if available
    const block = el.closest('.block');
    if (block?.dataset.blockId) {
      data.block_id = block.dataset.blockId;
    }

    // Attach value or innerHTML
    if (el.value !== undefined) {
      data.new_value = el.value;
    } else if (el.innerHTML !== undefined) {
      data.new_value = el.innerHTML;
    }
    ajaxAction(data);
    debounceTimers.delete(el);
  }, 500);

  debounceTimers.set(el, timer);
}
